import USDT from "./USDTTESTNET.json";
import smartcontract from "./Smartcontract.json"

export const USDTtokenAddressTestnet = "0xaE6e203ca4Ed0Fa0Eee96A797da670ea1D62CE95"; 
export const USDTtokenABITest = USDT.abi;

export const SmartcontractAddress = "0xBd0D2BC5E6Dfea248060aD1CE590498A061d5cAb";
export const SmartcontractABI = smartcontract.abi;